export const GoogleAutocompleteSuggestionType = {
  SPECIFIC_ADDRESS: 'address',
  BUSINESS_ADDRESS: 'establishment'
};
